module.exports = __webpack_public_path__ + "img/server.91661b2f.gif";